// import 'react-app-polyfill/ie9'; // For IE 9-11 support
// import 'babel-polyfill'; // deprecated
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'array-flat-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { configureImageKit } from '@lemonadefashion/imagekit';

import './semantic-ui-css-fix/components/reset.min.css';
import './semantic-ui-css-fix/components/site.min.css';
import './semantic-ui-css-fix/components/button.min.css';
// import './semantic-ui-css-fix/components/container.min.css';
import './semantic-ui-css-fix/components/divider.min.css';
// import './semantic-ui-css-fix/components/header.min.css';
import './semantic-ui-css-fix/components/icon.min.css';
// import './semantic-ui-css-fix/components/image.min.css';
import './semantic-ui-css-fix/components/input.min.css';
import './semantic-ui-css-fix/components/label.min.css';
// import './semantic-ui-css-fix/components/list.min.css';
import './semantic-ui-css-fix/components/loader.min.css';
import './semantic-ui-css-fix/components/placeholder.min.css';
// import './semantic-ui-css-fix/components/rail.min.css';
// import './semantic-ui-css-fix/components/reveal.min.css';
import './semantic-ui-css-fix/components/segment.min.css';
import './semantic-ui-css-fix/components/breadcrumb.min.css';
import './semantic-ui-css-fix/components/form.min.css';
import './semantic-ui-css-fix/components/grid.min.css';
import './semantic-ui-css-fix/components/message.min.css';
import './semantic-ui-css-fix/components/table.min.css';
// import './semantic-ui-css-fix/components/ad.min.css';
// import './semantic-ui-css-fix/components/item.min.css';
// import './semantic-ui-css-fix/components/card.min.css';
// import './semantic-ui-css-fix/components/comment.min.css';
import './semantic-ui-css-fix/components/feed.min.css';
import './semantic-ui-css-fix/components/menu.min.css';
// import './semantic-ui-css-fix/components/item.min.css';
// import './semantic-ui-css-fix/components/statistic.min.css';
// import './semantic-ui-css-fix/components/accordion.min.css';
import './semantic-ui-css-fix/components/checkbox.min.css';
import './semantic-ui-css-fix/components/dimmer.min.css';
import './semantic-ui-css-fix/components/dropdown.min.css';
// import './semantic-ui-css-fix/components/video.min.css';
import './semantic-ui-css-fix/components/modal.min.css';
// import './semantic-ui-css-fix/components/nag.min.css';
import './semantic-ui-css-fix/components/popup.min.css';
// import './semantic-ui-css-fix/components/progress.min.css';
import './semantic-ui-css-fix/components/rating.min.css';
// import './semantic-ui-css-fix/components/search.min.css';
// import './semantic-ui-css-fix/components/shape.min.css';
// import './semantic-ui-css-fix/components/sidebar.min.css';
import './semantic-ui-css-fix/components/sticky.min.css';
import './semantic-ui-css-fix/components/tab.min.css';
import './semantic-ui-css-fix/components/transition.min.css';

import 'react-toastify/dist/ReactToastify.css';
import './inter.css';
import './arabic_font.css';
import './index.css';

import registerServiceWorker from './registerServiceWorker';
import { Provider, Subscribe } from 'unstated';
import { Route, BrowserRouter } from 'react-router-dom';
import { verifyHost } from './verify_host';
import { initializeFacebookPixel } from './tracking/fb_pixel';
import { initializeGoogleTrackers } from './tracking/google';
import { initializeSentry } from './init_sentry';
import { initializeBranchIO } from './init_branch';

import CartContainer from './containers/cart_container';
import FavoritesContainer from './containers/favorites_container';
import AuthTokenContainer from './containers/auth_token_container';
import ShownPopupsContainer from './containers/shown_popups_container';
import CheckoutInfoContainer from './containers/checkout_info_container';
import I18nSettingsContainer from './containers/i18n_settings_container';
import SellersContainer from './containers/sellers_container';
import GuestAccessCodeContainer from './containers/guest_access_code_container';
import LatestTransactionIdContainer from './containers/latest_transaction_id_container';
import LastTimeLogoAnimationPlayedContainer from './containers/logo_animation_container';
import ActivationContainer from './containers/activation_container';

import App from './App';

import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
Amplify.configure(awsconfig);

// Always do this first, as we need to ensure that
// this client is being hosted by a valid domain.
verifyHost();

// Sentry first, because it will report errors.
initializeSentry();

// Initialize the rest of the things. The order of these shouldn't matter too much I guess.
initializeGoogleTrackers();
initializeFacebookPixel();
initializeBranchIO();

configureImageKit(
  process.env.REACT_APP_IMAGEKIT_ORIGIN,
  process.env.REACT_APP_IMAGEKIT_ACCOUNT_NAME,
  window.devicePixelRatio);

// This disables overscroll behavior on iOS which is nice.
// I believe it should fix that stupid bug related to the white overscroll covering our content.
// document.body.addEventListener('touchstart', (event) => {
//   event.preventDefault();
// }, { passive: false });

// How much time in between possible vh unit updates?
const VH_UPDATE_INTERVAL_MS = 300;

let _lastSetVH = null;
const updateVH = () => {
  const vh = window.innerHeight * 0.01;
  // It is ABSOLUTELY CRITICAL that we only update when necessary because changing CSS properties can trigger a repaint.
  if (_lastSetVH == null || _lastSetVH !== vh) {
    // TODO(moe): We should look into env(safe-area-inset-bottom) to take care of discrepencies
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    _lastSetVH = vh;
  }
};

updateVH();

// window.addEventListener('resize', updateVH);
// We do this as a mitigation against things like iOS 15's viewport height failure.
// It is also better to do this than to use the window resize event because this guarantees
// that we are debouncing the changes.
setInterval(updateVH, VH_UPDATE_INTERVAL_MS);

const containerList = [
  AuthTokenContainer, CartContainer,
  CheckoutInfoContainer, I18nSettingsContainer, SellersContainer,
  ShownPopupsContainer, FavoritesContainer, GuestAccessCodeContainer,
  LastTimeLogoAnimationPlayedContainer, LatestTransactionIdContainer, ActivationContainer
];

/*
* https://github.com/facebook/react/issues/9214#issuecomment-353161691
* Refer to the link above to understand why there is a Route directly
* inside the BrowserRouter. We're attempting to fix a bug related to
* the back button (which seems to appear on iOS 12).
* Status: not fixed, still needs work.
*/
const WrappedApp = (authTokenContainer, cart,
  checkoutInfoContainer, i18nSettingsContainer, sellersContainer,
  shownPopupsContainer, favoritesContainer, guestAccessCodeContainer,
  lastTimeLogoAnimationPlayedContainer, latestTransactionIdContainer, ActivationContainer) => {
  return (
    <BrowserRouter>
      {/* eslint-disable-next-line react/jsx-no-bind */}
      <Route render={(props) =>
          <App cart={cart} i18nSettings={i18nSettingsContainer}
            authTokenContainer={authTokenContainer} ActivationContainer={ActivationContainer}
            sellersContainer={sellersContainer} favoritesContainer={favoritesContainer}
            shownPopupsContainer={shownPopupsContainer} checkoutInfoContainer={checkoutInfoContainer}
            guestAccessCodeContainer={guestAccessCodeContainer}
            lastTimeLogoAnimationPlayedContainer={lastTimeLogoAnimationPlayedContainer}
            latestTransactionIdContainer={latestTransactionIdContainer}
            {...props} />} />
    </BrowserRouter>
  );
};

ReactDOM.render(
  <Provider>
    <Subscribe to={containerList}>
      {WrappedApp}
    </Subscribe>
  </Provider>, document.getElementById('root'));

registerServiceWorker(() => {});
